import { z } from 'zod';

// Copied identically from backend/resource-gateway/src/models/common.ts
export enum ResourceDefinitionStorageType {
  Fhir = 'Fhir',
  Custom = 'Custom',
}

// Copied identically from backend/resource-gateway/src/domains/resource-access/interfaces/types/resourceSchema.ts
export enum ResourceDefinitionScalarFieldType {
  String = 'String',
  Number = 'Number',
  Boolean = 'Boolean',
  Date = 'Date',
  Datetime = 'Datetime',
  Uuid = 'Uuid',
  Json = 'Json',
}

export enum ResourceDefinitionCardinality {
  ZeroToOne = 'ZeroToOne',
  OneToOne = 'OneToOne',
  ZeroToMany = 'ZeroToMany',
  OneToMany = 'OneToMany',
}

const FieldBase = z.object({
  cardinality: z
    .nativeEnum(ResourceDefinitionCardinality)
    .default(ResourceDefinitionCardinality.OneToOne),
  description: z.string().optional(),
});

const ScalarField = FieldBase.extend({
  type: z.nativeEnum(ResourceDefinitionScalarFieldType),
}).strict();

const RelationshipField = FieldBase.extend({
  type: z.literal('relationship'),
  resourceKey: z.union([z.string(), z.array(z.string())]),
  isAutoGenerated: z.boolean().optional(),
}).strict();

const ComplexTypeField = FieldBase.extend({
  type: z.literal('complex'),
  complexType: z.string(),
}).strict();

interface ObjectFieldType {
  type: 'object';
  cardinality: ResourceDefinitionCardinality;
  description?: string;
  fields: Record<string, ResourceFieldDefinition>;
}

const ObjectField: z.ZodType<ObjectFieldType> = z.lazy(() =>
  FieldBase.extend({
    type: z.literal('object'),

    fields: z.record(z.string(), ResourceFieldDefinitionSchema),
  }).strict()
);

export const ResourceFieldDefinitionSchema = z.union([
  ScalarField,
  RelationshipField,
  ComplexTypeField,
  ObjectField,
]);
export type ResourceFieldDefinition = z.infer<typeof ResourceFieldDefinitionSchema>;

export const ResourceSchemaDefinitionSchema = z.object({
  primaryKey: z.union([z.string(), z.array(z.string())]),
  displayName: z.string().optional(),
  fields: z.record(z.string(), ResourceFieldDefinitionSchema),
});
export type ResourceSchemaDefinition = z.infer<typeof ResourceSchemaDefinitionSchema>;

export const ResourceDefinitionSummarySchema = z.object({
  id: z.string(),
  created: z.coerce.date(),
  updated: z.coerce.date(),
  name: z.string(),
  description: z.string().nullable(),
  resourceKey: z.string(),
  storageType: z.nativeEnum(ResourceDefinitionStorageType),
  version: z.number(),
  organizationId: z.string().nullable(),
});
export type ResourceDefinitionSummary = z.infer<typeof ResourceDefinitionSummarySchema>;

export const ResourceDefinitionSchema = ResourceDefinitionSummarySchema.extend({
  schema: ResourceSchemaDefinitionSchema,
});
export type ResourceDefinition = z.infer<typeof ResourceDefinitionSchema>;

export interface ResourceDefinitionFindAllOptions {
  organizationId?: string;
  resourceKey?: string;
  storageType?: ResourceDefinitionStorageType;
}
